<template>
    <li :class="setCustomClassess">
        <a :href="item.href" v-if="item.href" v-on:click="onClickMenuItem" :data-cktag="item.title">{{item.title}}</a>
        <span v-if="!item.href">{{item.title}}</span>
    </li>
</template>

<script>
  export default {
    props: ['item'],
    computed: {
      setCustomClassess() {
        let _customClasses = '';
        if (typeof this.item.customClass === 'string' && this.item.customClass.length > 0) {
          _customClasses = this.item.customClass;
        }
        if (this.item.title === '-') {
          _customClasses = _customClasses + ' divider';
        }
        if (typeof this.item.href !== 'undefined' && this.item.href.length < 1 && this.item.title.length > 0 && this.item.title !== '-') {
          _customClasses = _customClasses + ' menuSubHeading';
        }
        return _customClasses;
      },
    },
    methods: {
      onClickMenuItem() {
        this.$emit('ItemClicked', this);
      },
    },
  };
</script>
